module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "fmh123",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xi",
      "title": "xi"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062653710_Contents#r_idParaDest-3"
    }
  }, [_vm._v("THE SORCERESS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tonight, I will make the Alchemist’s blood—Jules Ember’s blood—into a weapon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stand in a room deep below the ballrooms and balconies of Shorehaven. A timelender hunches across from me, sweating as he mixes powders at his workbench. He’s the latest in a long line of timelenders I’ve commissioned to lure the Alchemist out of hiding. All have been inadequate so far; all have died for it. But something tells me tonight will be different.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The air prickles with danger. With promise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The people of Sempera are so uncreative with their precious time, their blood-irons. When they don’t drink them like beasts, they fritter them away to make their flowers bloom, or feed them to their fires to make themselves warm in the winter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But the right blood-iron could burn down the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the timelender tips the vial of Jules Ember’s blood into his little cauldron, light flashes through the room—as if we’re not far underground, as if day has come early and all at once. The ash and grime billow around me before the "), _c('i', [_vm._v("boom")]), _vm._v(" knocks us both off our feet. For an instant, flight. I think of the world as a hide "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xii",
      "title": "xii"
    }
  }, [_vm._v("stretched taut across the frame of a war drum, the kind I remember from centuries ago. Someone’s just brought the mallet down.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even as my back hits the floorboards, my blood sings with triumph. An image burns behind my eyelids: a landscape of flames, the outline of a decrepit town with a pathetic name: "), _c('i', [_vm._v("Crofton")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I laugh to myself as I stagger to my feet. The timelender is lying prone on the floor, knocked there by the impact, gasping like a fish. “So it "), _c('i', [_vm._v("is")]), _vm._v(" you,” he murmurs. My true name, "), _c('i', [_vm._v("Sorceress")]), _vm._v(", dies on his lips.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Never mind that. Inside the bronze cauldron, giving off its own faint light, is a shifting, sparking liquid. No color and every color at the same time, the magic is hard to look at directly with these human eyes. The man dying at my feet has created it out of Sempera’s finest diamonds and only one year of the blood-iron sweet Jules Ember left behind at Everless.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I bring the small cauldron to my lips and drink the Alchemist’s time. Just a little.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have plans for the rest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pain lances my throat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I breathe, alive, grip the edge of the table as my weak body shudders. I wait for the time to coalesce into a thousand daggers like it did that night at Everless, the night I finally realized who Jules Ember was under her skin, in her heart. I wait for her time to fight its way out of me like something alive.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That doesn’t happen. Instead, power seeps into me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xiv",
      "title": "xiv"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xiii",
      "title": "xiii"
    }
  }, [_vm._v("Energy courses through the room, magic in every particle just waiting to be unlocked and set loose on the world, snarling like a pack of wild dogs.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I pour a few drops of the liquid into a bottle, dark green to hide its contents’ diamond quality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Aboveground, I hand the bottle to the Everless boy Ivan Tenburn. He’s afraid of me now; he holds it like it will bite him. Good. I need him to be careful. I need our creation to make it to Crofton intact.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Where it will deliver the Alchemist to me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Make me a fire,” I whisper into Ivan’s ear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xvi",
      "title": "xvi"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-020d727a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062653710_Frontmatter1.vue
// module id = 69
// module chunks = 0